export default __webpack_public_path__ + "static/media/img_17.100a50c2.JPG";